<template>
  <div class="profile">
    <section class="profile-banner">
      <!-- You can add your banner content here -->
    </section>

    <!-- Avatar Section -->
    <section class="avatar-section">
      <div class="container">
        <div class="row">
          <div class="col-md-6">
            <div class="avatar">
              <div class="loggedin-avatar"><img :src="user.image" alt="User Avatar" /></div>
              <h4 class="name capitalize">{{ user.name }}</h4>
              <h6 class="email">{{ user.email }}</h6>
            </div>
          </div>
          <div class="col-md-6 account-btn-col">
            <!-- <div class="account-btns">
              <button class="btn primary">Manage account</button>
              <button class="btn secondary">Sign out</button>
            </div> -->
          </div>
        </div>
      </div>
    </section>

    <!-- Profile Tabs -->
    <section class="profile-tabs">
      <div class="container">
        <div class="nav-parent">
          <ul class="nav nav-tabs mb-4" id="profileTab" role="tablist">
            <li class="nav-item" role="presentation">
              <button class="nav-link active" data-bs-toggle="tab" data-bs-target="#profile" type="button">
                Profile
              </button>
            </li>
            <!-- <li class="nav-item" role="presentation">
              <button class="nav-link" data-bs-toggle="tab" data-bs-target="#security" type="button">
                Security
              </button>
            </li> -->
            <li class="nav-item" role="presentation">
              <button class="nav-link" data-bs-toggle="tab" data-bs-target="#subscription" type="button">
                Subscription
              </button>
            </li>
            <!-- <li class="nav-item" role="presentation">
              <button class="nav-link" data-bs-toggle="tab" data-bs-target="#payments" type="button">
                Payments
              </button>
            </li> -->
          </ul>
        </div>

        <div class="tab-content" id="profileTabContent">
          <!-- Profile Tab -->
          <div class="tab-pane fade show active" id="profile" role="tabpanel">
            <div class="card">
              <div class="section-divider"></div>

              <!-- Profile Photo -->
              <div class="form-section">
                <div class="col1">
                  <h5>Profile Photo</h5>
                  <small class="text-muted">Edit profile photo</small>
                </div>
                <div class="col2">
                  <div class="profile-wrapper">
                    
                    <div class="loggedin-avatar sm"><img :src="user.image" alt="User Avatar" /></div>

                    <!-- <div class="d-flex gap-2 mt-2">
                      <button class="btn btn-purple" @click="triggerImageInput">Update</button>
                      <button class="btn btn-grey" @click="removeImage">Remove</button>
                    </div> -->
                  </div>
                </div>
              </div>

              <div class="section-divider"></div>

              <!-- Email -->
              <div class="form-section">
                <div class="col1">
                  <h5>Email Address</h5>
                  <small class="text-muted">Edit email address</small>
                </div>
                <div class="col2">
                  <p class="mt-2">{{ user.email }}</p>
                  <!-- <a href="javascript:void(0)" class="text-decoration-none text-light">+ Add email address</a> -->
                </div>
              </div>

              <div class="section-divider"></div>

              <!-- Phone -->
              <div class="form-section">
                <div class="col1">
                  <h5>Streak</h5>
                  <small class="text-muted">Streak</small>
                </div>
                <div class="col2">
                  <p class="mt-2">+ {{ user.streak }}</p>
                  <!-- <a href="javascript:void(0)" class="text-decoration-none text-light">+ Add phone number</a> -->
                </div>
              </div>

              <div class="section-divider"></div>

              <!-- Connected Accounts -->
              <div class="form-section">
                <div class="col1">
                  <h5>Coins</h5>
                  <small class="text-muted">Edit connected accounts</small>
                </div>
                <div class="col2">
                  <p class="mt-2">{{ user.coin }}</p>
                  <!-- <a href="javascript:void(0)" class="text-decoration-none text-light">+ Connect account</a> -->
                </div>
              </div>

              <!-- <div class="d-flex justify-content-end mt-4">
                <button class="btn btn-purple me-2">Save changes</button>
                <button class="btn btn-grey">Cancel</button>
              </div> -->
            </div>
          </div>

          <!-- Security Tab -->
          <div class="tab-pane fade" id="security" role="tabpanel">
            Security settings go here.
          </div>

          <!-- Subscription Tab -->
          <div class="tab-pane fade" id="subscription" role="tabpanel">
            <div class="section-divider"></div>
            <div class="subscriptionContent">
              <div class="row gx-4">
                <!-- Left Column -->
                <div class="col-md-6">
                  <div class="card plan-card p-4 h-100">
                    <h2 class="text-white">Free Plan</h2>
                    <div class="section-divider"></div>
                    <div class="d-flex">
                      <div>
                        <h5 class="text-white mb-2">For monthly $9.99<br />And annual $99</h5>
                      </div>
                      <div>
                      </div>
                    </div>
                    <p>
                     Free subscriptions include:</p>


                    <ul class="text-white-50 ps-3 list-style">
                      <li>Daily ROCKSTAR(t) Your Day videos: These videos disappear daily. </li>

                              <li>Free content (It's limited, BUT, you can purchase coins, and buy anything you'd like on the app!)</li>

                              <li>Earn FREE coins, just by using the app daily. As you increase your daily streak, you earn more free coins to use for purchasing more content. </li>

                              <li>Free Sharing with Friends: Often, you will come across content on the app that someone you know or love could really use.  Go ahead and share it, absolutely FREE!</li>

                              <li>We’ll make sure there’s always free content available to you in the app. If you decide to buy one tiny thing for a couple dollars, it helps support the app. We would be so very grateful 🙏. Xo, Sandy. </li>  
                    </ul>
                  </div>
                </div>

                <!-- Right Column -->
                <div class="col-md-6">
                  <div class="card plan-card p-4 h-100 text-center">
                    <h2 class="text-white mb-2">Download the App</h2>
                    <p class="text-white-50 small">
                      Learn from the best to be your best. Download our app and take the ROCKSTAR experience
                      anywhere!
                    </p>
                    <div class="d-flex justify-content-center gap-2 my-3">
                      <img src="@/assets/images/app-store.png" height="40" alt="App Store" />
                      <img src="@/assets/images/google-play.png" height="40" alt="Google Play" />
                    </div>
                    <img src="@/assets/images/Group19.png" alt="App Preview" class="img-fluid" />
                  </div>
                </div>
              </div>

              <!-- <div class="d-flex justify-content-end mt-4 gap-3">
                <button class="btn btn-purple">Upgrade Plan</button>
                <button class="btn btn-danger">Cancel</button>
              </div> -->
            </div>
          </div>

          <!-- Payments Tab -->
          <div class="tab-pane fade" id="payments" role="tabpanel">
            Payment info goes here.
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "HomePage",
  inject: ['api'],
  mounted() {
    this.loadUserData();
  },
  data() {
    return {
      previewImage: null,
      user: {
        name: '',
        email: '',
        phone: '',
        coin: '',
        image : '',
        streak : '',
      }
    };
  },
  methods: {
    loadUserData() {
      const userDataString = localStorage.getItem('rockstar_user');
      if (userDataString) {
        try {
          const userData = JSON.parse(userDataString);
          this.user.name = userData.first_name || '';
          this.user.email = userData.email || '';
          this.user.phone = userData.phone || '';
          this.user.image = userData.image || '';
          this.user.streak = userData.user_streak || 0;
          this.user.coin = userData.coin || 0;
          console.log(this.user);
          // this.user.connectedAccount = userData.connectedAccount || '';
        } catch (error) {
          console.error('Error parsing rockstar_user data:', error);
        }
      } else {
        console.warn('No rockstar_user data found in localStorage.');
      }
    },
    triggerImageInput() {
      this.$refs.imageInput.click();
    },
    onImageChange(e) {
      const file = e.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = (event) => {
          this.previewImage = event.target.result;
        };
        reader.readAsDataURL(file);
      }
    },
    removeImage() {
      this.previewImage = null;
      this.$refs.imageInput.value = null;
    },
  },
};
</script>

<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
